/**
 * ApplyPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Row,
  Col,
  Text,
  InputFormTable,
  Title,
  Button,
} from 'components';
import { Divider, Flex, Input, Select, Button as Btn } from 'antd';
import { openAddressModal } from 'utils/DaumAPIManager';
import Formatter from 'utils/Formatter';
import {
  AuditOutlined,
  UploadOutlined,
  UserAddOutlined,
} from '@ant-design/icons';

// 입금은행
const BANK_LIST = [
  '카카오뱅크',
  '국민은행',
  '기업은행',
  '농협은행',
  '신한은행',
  'iM뱅크',
  '산업은행',
  '우리은행',
  '한국씨티은행',
  '하나은행',
  'SC제일은행',
  '경남은행',
  '광주은행',
  '도이치은행',
  '뱅크오브아메리카',
  '부산은행',
  '산림조합중앙회',
  '저축은행',
  '새마을금고',
  '수협은행',
  '신협중앙회',
  '우체국',
  '전북은행',
  '제주은행',
  '중국건설은행',
  '중국공상은행',
  '중국은행',
  'BNP파리바은행',
  'HSBC은행',
  'JP모간체이스은행',
  '케이뱅크',
  '토스뱅크',
];

/**----------------------------------------
 * [Component] 입점업체 등록: 프레젠터
 * ----------------------------------------
 */
const ApplyPresenter = (props) => {
  /* ===== ROUTE ===== */

  /* ===== PROPS ===== */
  const {
    nameRef,
    contentRef,
    storeNumRef,
    businessNumRef,
    addressRef,
    addressDetailRef,
    ownerRef,
    shopInformation,
    onSubmit,
    onChange,
    storeInformation,

    adminInformation,
    businessFile,
    setBusinessFile,
  } = props;

  /* ===== STATE ===== */
  const fileRef = React.useRef(null);

  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**--------------------
   * 다음 주소 검색 Popup Open
   * --------------------
   */
  const handleOpen = () => {
    openAddressModal((res) => {
      onChange('shopInformation', 'shop_information_postcode', res.zonecode);
      onChange('shopInformation', 'shop_information_address', res.address);
    });
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={800} padding={20} minHeight={'100vh'}>
      <Row>
        <Col x={24}>
          <Content maxWidth={'100%'} padding={0}>
            {/* === 타이틀 === */}
            <Text
              size={30}
              style={{
                fontFamily: `'Dela Gothic One', sans-serif`,
                margin: '30px 0px',
              }}
              align={'center'}
            >
              JM COFFEE 쇼핑몰 가입
            </Text>
            <Divider />

            {/* === 쇼핑몰 정보 입력 === */}
            <Title size={4} align={'left'}>
              <AuditOutlined /> 쇼핑몰 정보
            </Title>
            <InputFormTable
              labelWidth={165}
              form={[
                {
                  label: '브랜드명',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input
                          ref={nameRef}
                          size="large"
                          value={shopInformation.shop_information_name}
                          onChange={(e) =>
                            onChange(
                              'shopInformation',
                              'shop_information_name',
                              e.target.value
                            )
                          }
                          placeholder="브랜드명을 입력해주세요"
                          showCount
                          count={{
                            max: 20,
                            show: true,
                          }}
                          style={{ ...styles.form.input.large, width: 500 }}
                        />
                      ),
                    },
                  ],
                },
                {
                  label: '브랜드 설명',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input.TextArea
                          ref={contentRef}
                          size="large"
                          value={shopInformation.shop_information_content}
                          onChange={(e) =>
                            onChange(
                              'shopInformation',
                              'shop_information_content',
                              e.target.value
                            )
                          }
                          placeholder="브랜드 설명을 입력해주세요"
                          showCount
                          rows={4}
                          count={{
                            max: 250,
                            show: true,
                          }}
                          style={{
                            ...styles.form.input.large,
                            width: 500,
                            marginBottom: 15,
                          }}
                        />
                      ),
                    },
                  ],
                },
                {
                  label: '주소',
                  required: true,
                  direction: 'column',
                  form: [
                    {
                      input: (
                        <>
                          <Input
                            size="large"
                            value={shopInformation.shop_information_postcode}
                            placeholder="우편번호"
                            readOnly
                            style={{ width: 300 }}
                            ref={addressRef}
                          />
                          <Button size="large" onClick={() => handleOpen()}>
                            주소찾기
                          </Button>
                        </>
                      ),
                    },
                    {
                      input: (
                        <>
                          <Input
                            size="large"
                            value={shopInformation.shop_information_address}
                            placeholder="주소"
                            readOnly
                            style={{ width: 500 }}
                          />
                        </>
                      ),
                    },
                    {
                      input: (
                        <>
                          <Input
                            size="large"
                            value={
                              shopInformation.shop_information_address_detail
                            }
                            onChange={(e) =>
                              onChange(
                                'shopInformation',
                                'shop_information_address_detail',
                                e.target.value
                              )
                            }
                            placeholder="상세주소"
                            style={{ width: 500 }}
                            ref={addressDetailRef}
                          />
                        </>
                      ),
                    },
                  ],
                },

                {
                  label: '매장 연락처',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input
                          ref={storeNumRef}
                          size="large"
                          value={storeInformation.store_num}
                          onChange={(e) =>
                            onChange(
                              'storeInformation',
                              'store_num',
                              Formatter.hyphen(e.target.value)
                            )
                          }
                          placeholder="매장 연락처를 입력해주세요"
                          showCount
                          count={{
                            max: 13,
                            show: true,
                          }}
                          maxLength={13}
                          style={{ ...styles.form.input.large, width: 500 }}
                        />
                      ),
                    },
                  ],
                },
                {
                  label: '사업자등록번호',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input
                          ref={businessNumRef}
                          size="large"
                          value={storeInformation.business_num}
                          onChange={(e) =>
                            onChange(
                              'storeInformation',
                              'business_num',
                              Formatter.hyphen(e.target.value, 'business_num')
                            )
                          }
                          placeholder="사업자등록번호를 입력해주세요"
                          count={{
                            max: 12,
                            show: true,
                          }}
                          maxLength={12}
                          style={{ ...styles.form.input.large, width: 500 }}
                        />
                      ),
                    },
                  ],
                },
                {
                  label: '대표자',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input
                          size="large"
                          value={storeInformation.store_owner}
                          onChange={(e) =>
                            onChange(
                              'storeInformation',
                              'store_owner',
                              e.target.value
                            )
                          }
                          placeholder="대표자명을 입력해주세요"
                          count={{
                            max: 12,
                            show: true,
                          }}
                          maxLength={12}
                          style={{ ...styles.form.input.large, width: 500 }}
                          ref={ownerRef}
                        />
                      ),
                    },
                  ],
                },
                {
                  label: '입금은행',
                  required: true,
                  form: [
                    {
                      input: (
                        <Select
                          size="large"
                          value={storeInformation.bank_name}
                          placeholder="입금은행을 선택해주세요"
                          onChange={(e) =>
                            onChange('storeInformation', 'bank_name', e)
                          }
                          options={BANK_LIST.map((item) => ({
                            label: item,
                            value: item,
                          }))}
                        />
                      ),
                    },
                  ],
                },
                {
                  label: '입금계좌',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input
                          size="large"
                          value={storeInformation.account_number}
                          onChange={(e) =>
                            onChange(
                              'storeInformation',
                              'account_number',
                              e.target.value
                            )
                          }
                          placeholder="입금계좌를 입력해주세요"
                          count={{
                            max: 24,
                            show: true,
                          }}
                          maxLength={24}
                          style={{ ...styles.form.input.large, width: 500 }}
                        />
                      ),
                    },
                  ],
                },

                {
                  label: '사업자등록증',
                  required: true,
                  form: [
                    {
                      input: (
                        <Flex align="center" gap={10}>
                          <input
                            ref={fileRef}
                            type="file"
                            accept="image/*"
                            onChange={(e) => setBusinessFile(e.target.files[0])}
                            style={{ display: 'none' }}
                          />

                          <Text size={12} color={'#666666'}>
                            {businessFile
                              ? businessFile?.name
                              : '파일을 업로드해주세요'}
                          </Text>

                          <Btn
                            icon={<UploadOutlined />}
                            onClick={() => fileRef.current.click()}
                          >
                            파일 업로드
                          </Btn>
                        </Flex>
                      ),
                    },
                  ],
                },
              ]}
            />
            <br />
            <br />

            {/* === 계정정보 등록 === */}
            <Title size={4} align={'left'}>
              <UserAddOutlined /> 계정정보{' '}
            </Title>
            <InputFormTable
              labelWidth={165}
              form={[
                {
                  label: '관리자 아이디',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input
                          size="large"
                          value={adminInformation.admin_account}
                          onChange={(e) =>
                            onChange(
                              'adminInformation',
                              'admin_account',
                              e.target.value
                            )
                          }
                          placeholder="아이디를 입력해주세요"
                          showCount
                          count={{
                            max: 40,
                            show: true,
                          }}
                          style={{ ...styles.form.input.large, width: 500 }}
                        />
                      ),
                    },
                  ],
                },
                {
                  label: '관리자 패스워드',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input
                          size="large"
                          type="password"
                          value={adminInformation.password}
                          onChange={(e) =>
                            onChange(
                              'adminInformation',
                              'password',
                              e.target.value
                            )
                          }
                          placeholder="패스워드(8자리 이상)를 입력해주세요"
                          count={{
                            min: 8,
                            show: true,
                          }}
                          style={{ ...styles.form.input.large, width: 500 }}
                        />
                      ),
                    },
                  ],
                },
                {
                  label: '담당자',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input
                          size="large"
                          value={adminInformation.admin_name}
                          onChange={(e) =>
                            onChange(
                              'adminInformation',
                              'admin_name',
                              e.target.value
                            )
                          }
                          placeholder="담당자명을 입력해주세요"
                          count={{
                            min: 8,
                            show: true,
                          }}
                          style={{ ...styles.form.input.large, width: 500 }}
                        />
                      ),
                    },
                  ],
                },
                {
                  label: '담당자 연락처',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input
                          size="large"
                          value={adminInformation.admin_phone}
                          onChange={(e) =>
                            onChange(
                              'adminInformation',
                              'admin_phone',
                              e.target.value
                            )
                          }
                          placeholder="담당자 연락처를 입력해주세요"
                          count={{
                            min: 8,
                            show: true,
                          }}
                          style={{ ...styles.form.input.large, width: 500 }}
                        />
                      ),
                    },
                  ],
                },
                {
                  label: '담당자 이메일',
                  required: true,
                  form: [
                    {
                      input: (
                        <Input
                          size="large"
                          value={adminInformation.admin_email}
                          onChange={(e) =>
                            onChange(
                              'adminInformation',
                              'admin_email',
                              e.target.value
                            )
                          }
                          placeholder="담당자 이메일을 입력해주세요"
                          count={{
                            min: 8,
                            show: true,
                          }}
                          style={{ ...styles.form.input.large, width: 500 }}
                        />
                      ),
                    },
                  ],
                },
              ]}
            />

            <Content
              maxWidth={'100%'}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 20,
              }}
            >
              <Button
                size="large"
                style={{ width: '40%' }}
                onClick={() => onSubmit()}
              >
                등록하기
              </Button>
            </Content>
          </Content>
        </Col>
      </Row>
    </Content>
  );
};

const styles = {
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 20,
  },
  subTitle: {
    fontSize: 17,
    fontWeight: 500,
    lineHeight: '141%',
    marginBottom: 20,
  },
  button: {
    width: 80,
    height: 40,
    fontSize: 15,
    fontWeight: 600,
    margin: '0px 4px',
  },
  form: {
    input: {
      large: {
        width: 175,
        marginRight: 8,
      },
      medium: {
        width: 100,
        marginRight: 8,
      },
    },
    button: {
      marginRight: 8,
    },
    date: {
      width: 120,
    },
    text: {
      fontSize: 13,
      fontWeight: 400,
    },
  },
  linkButton: {
    border: 'none',
    background: 'none',
    fontSize: 12,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
};

export default ApplyPresenter;
